import { useCard } from '@orbital/games-frontend-library'
import React from 'react'
import { colors } from '../../lib/colors'
import { CardFrontWrapper, CardWrapper, Cardback } from './Styles'
import CardContent from './CardContent'
import { CARD_WITH_BACK_PROPS } from './interface'

export const CardWithBack = ({
  background,
  card,
  deal,
  dealOut,
  animDelay,
  flipCard,
  showResult,
}: CARD_WITH_BACK_PROPS): JSX.Element => {
  const { handleCardColor } = useCard()
  return (
    <CardWrapper flipCard={flipCard} dealOut={dealOut} delay={200}>
      <CardFrontWrapper
        background={background}
        suitColor={handleCardColor(card, colors.cardRed, colors.cardBlack)}
        deal={deal}
        flipCard={flipCard}
        animDelay={animDelay}
        showResult={showResult}
      >
        <CardContent card={card} />
      </CardFrontWrapper>
      <Cardback
        className='back'
        deal={deal}
        flipCard={flipCard}
        animDelay={animDelay}
      />
    </CardWrapper>
  )
}
